export default {
  Yo: "allowCrawlerActivity",
  Zo: "baseUrl",
  Wh: "noCookies",
  Vh: "devicePropertyAllowlist",
  Da: "disablePushTokenMaintenance",
  $h: "enableLogging",
  Yh: "enableSdkAuthentication",
  Ca: "manageServiceWorkerExternally",
  Xh: "minimumIntervalBetweenTriggerActionsInSeconds",
  Zh: "sessionTimeoutInSeconds",
  Qh: "appVersion",
  Ea: "appVersionNumber",
  _a: "serviceWorkerLocation",
  Ba: "safariWebsitePushId",
  Zn: "localization",
  er: "contentSecurityNonce",
  re: "allowUserSuppliedJavascript",
  Go: "inAppMessageZIndex",
  Ko: "openInAppMessagesInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Ia: "doNotLoadFontAwesome",
  Na: "deviceId",
  Aa: "serviceWorkerScope",
  Oa: "sdkFlavor",
  tn: "openCardsInNewTab"
};